/**
 * Centralized logging utility for the application
 * Replaces console.log/error/warn with proper logging infrastructure
 */

const LOG_LEVELS = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
};

const currentLogLevel = process.env.NODE_ENV === 'production' ? LOG_LEVELS.WARN : LOG_LEVELS.DEBUG;

const logger = {
    debug: (message, ...args) => {
        if (currentLogLevel <= LOG_LEVELS.DEBUG) {
            console.debug(`[DEBUG] ${message}`, ...args);
        }
    },
    info: (message, ...args) => {
        if (currentLogLevel <= LOG_LEVELS.INFO) {
            console.info(`[INFO] ${message}`, ...args);
        }
    },
    warn: (message, ...args) => {
        if (currentLogLevel <= LOG_LEVELS.WARN) {
            console.warn(`[WARN] ${message}`, ...args);
        }
    },
    error: (message, error, ...args) => {
        if (currentLogLevel <= LOG_LEVELS.ERROR) {
            const errorDetails = error instanceof Error 
                ? { message: error.message, stack: error.stack, ...error }
                : error;
            console.error(`[ERROR] ${message}`, errorDetails, ...args);
        }
    },
};

export default logger;

